import request from "@/utils/request";
export function findMedicine(data) {
  return request({
    //url: "/rpc/medicine/findMedicine",
    url: "/medicineManager/findAllMedicine",
    method: "post",
    data: data
  });
}
export function updateMedicine(id, data) {
  return request({
    url: "/pharmacy/updateMedicine/" + id,
    method: "post",
    data: data
  });
}
export function updateMedicineUsage(data) {
  return request({
    url: "/medicine/updateUsage",
    method: "post",
    data: data
  });
}
export function insertMedicineQty(data) {
  return request({
    url: "/medicineManager/insertMedicineQty",
    method: "post",
    data: data
  });
}
export function reduceMedicineQty(data) {
  return request({
    url: "/medicineManager/reduceMedicineQty",
    method: "post",
    data: data
  });
}
export function getLevelList(data) {
  return request({
    url: "/app/medicine/levelList",
    method: "post",
    data: data
  });
}
/**
 * 获取绑定药房管理员二维码
 */
export function getYdAdminQrCode(id) {
  return request({
    url: "/rpc/wechat/getYdAdminQrCode?id=" + id,
    method: "post"
  });
}
/**
 * 获取绑定药房普通二维码
 */
export function getYdNormalQrCode(id) {
  return request({
    url: "/rpc/wechat/getYdNormalQrCode?id=" + id,
    method: "post"
  });
}
/**
 * 批量导入
 */
export function batchCreateMedicine(data) {
  return request({
    url: "/pharmacy/batchCreateMedicine",
    method: "post",
    data: data
  });
}

export function batchCreateMedicineParent(data) {
  return request({
    url: "/mediciParentneManager/batchCreateMedicineParent",
    method: "post",
    data: data
  });
}

/**
 * 库存明细
 */
export function findMedicineQty(data) {
  return request({
    url: "/medicineManager/findMedicineQty",
    method: "post",
    data: data
  });
}
/**
 * 获取员工列表
 */
export function listAccount(data) {
  return request({
    url: "/pharmacy/listAccount",
    method: "post",
    data: data
  });
}
/**
 * 删除员工
 */
export function deleteAccount(data) {
  return request({
    url: "/pharmacy/deleteAccount",
    method: "post",
    data: data
  });
}
/**
 * 员工审核
 */
export function pharmacyAudit(data) {
  return request({
    url: "/pharmacy/auditAccount",
    method: "post",
    data: data
  });
}
/**
 * 编辑员工信息
 */
export function updateAccountByOpenId(data) {
  return request({
    url: "/pharmacy/updateAccountByOpenId",
    method: "post",
    data: data
  });
}
/**
 * 密码修改
 */
export function updatePassword(data) {
  return request({
    url: "/adminMng/updatePassword",
    method: "post",
    data: data
  });
}
/**
 * 药房列表
 */
export function findPharmacy(data) {
  return request({
    url: "/platform/findPharmacy",
    method: "post",
    data: data
  });
}
/**
 * 药房列表
 */
export function updateStock(data) {
  return request({
    url: "/medicineManager/updateLotNumber",
    method: "post",
    data: data
  });
}
export function insert2MedicineQty(data) {
  return request({
    url: "/medicineManager/insert2MedicineQty",
    method: "post",
    data: data
  });
}
//更新总代产品
export function updateMedicineParent(id, data) {
  return request({
    url: "/pharmacy/updateMedicineParent/" + id,
    method: "post",
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/pharmacyMS.js